import { render, staticRenderFns } from "./Copilot.vue?vue&type=template&id=de0f4a86&scoped=true&"
import script from "./Copilot.vue?vue&type=script&lang=js&"
export * from "./Copilot.vue?vue&type=script&lang=js&"
import style0 from "./Copilot.vue?vue&type=style&index=0&id=de0f4a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0f4a86",
  null
  
)

export default component.exports